module.exports = __webpack_public_path__ + "img/document.eb241d79.png";